import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonSlideTextComponent } from './button-slide-text/button-slide-text.component';
import { MatRippleModule } from '@angular/material/core';

@NgModule({
  declarations: [ButtonSlideTextComponent],
  exports: [ButtonSlideTextComponent],
  imports: [
    MatRippleModule,
    CommonModule
  ]
})
export class ButtonSlideTextModule { }
